import React from "react";
import { Box, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInbox } from "@fortawesome/free-solid-svg-icons";

const EmptyState = ({
  icon,
  title = "No data found",
  subtitle = "There are no records to display.",
  action,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 8,
        px: 3,
        textAlign: "center",
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: "50%",
          background: "linear-gradient(135deg, #eef0f6, #e8eaf6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 3,
          color: "#8b8fa3",
          fontSize: 30,
        }}
      >
        {icon || <FontAwesomeIcon icon={faInbox} />}
      </Box>
      <Typography
        sx={{ fontWeight: 600, color: "#1a1a2e", mb: 0.5, fontSize: "1.1rem" }}
      >
        {title}
      </Typography>
      <Typography
        sx={{ color: "#8b8fa3", maxWidth: 360, fontSize: "0.875rem" }}
      >
        {subtitle}
      </Typography>
      {action && <Box sx={{ mt: 3 }}>{action}</Box>}
    </Box>
  );
};

export default EmptyState;
